import React, { useState, useEffect } from 'react';
import { useDebounce } from '@growth/custom-hooks/useDebounce';
import { D as Dropdown$1 } from '../../../dist/index-c92acf6a.esm.js';
import { S as SearchResultMenu } from '../../../dist/index-1b1e128d.esm.js';
import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';
import { textSizes } from '@growth/design-system';
import '../../../input-feild/dist/growth-form-controls-input-feild.esm.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var DropdownContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"])));
var Dropdown = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 58px;\n\tpadding: 18px 14px;\n\tfont-weight: 700;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #141823;\n\tborder: 1px solid rgba(0, 0, 0, 0.12);\n\tborder-radius: 4px;\n\tposition: relative;\n\tcursor: pointer;\n\t", "\n\t&::after {\n\t\tcontent: '';\n\t\tborder: solid #647a97;\n\t\tdisplay: inline-flex;\n\t\tborder-width: 0 2px 2px 0;\n\t\tpadding: 4px;\n\t\ttransform: ", ";\n\t\tposition: absolute;\n\t\tright: 17px;\n\t\ttop: 22px;\n\t}\n"])), function (p) {
  return p.isActive && "\n    border-color: #2276E3;\n  ";
}, function (props) {
  return props.isActive ? "rotate(225deg)" : "rotate(45deg)";
});
var SelectLabel = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tleft: 18px;\n\ttop: 19px;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #717171;\n\tfont-weight: 500;\n\ttransition: all 0.3s ease-in-out;\n\t", "\n"])), function (p) {
  return p.isSelected && "\n    left: 14px;\n    top: -11px;\n    font-size: 12px;\n    font-weight: 400;\n    background: #fff;\n    padding: 0 4px;\n  ";
});
var SelectedOption = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #141823;\n\tfont-weight: 500;\n"])));
styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tpadding: 16px 16px 0 16px;\n\tborder-radius: 20px 20px 0 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: left;\n\t", "\n\th3 {\n\t\tfont-size: 1.8rem;\n\t\tfont-weight: 700;\n\t\tcolor: #222;\n\t}\n\t.close {\n\t\tposition: absolute;\n\t\tright: 1.5rem;\n\t\ttop: 1.8rem;\n\t\twidth: 2.4rem;\n\t\theight: 2.4rem;\n\t}\n\t.close:before,\n\t.close:after {\n\t\tposition: absolute;\n\t\tleft: 1.1rem;\n\t\tcontent: ' ';\n\t\theight: 1.8rem;\n\t\twidth: 0.2rem;\n\t\tbackground-color: #141823;\n\t}\n\t.close:before {\n\t\ttransform: rotate(45deg);\n\t}\n\t.close:after {\n\t\ttransform: rotate(-45deg);\n\t}\n"])), textSizes.LargeW2);
var ModalInnerWrapper = styled.ul(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: calc(var(--100vh) - 46px);\n\toverflow-y: auto;\n"])));

function CityDropdown(props) {
  var fetchOptions = props.fetchOptions,
    onCitySelect = props.onCitySelect,
    _props$options = props.options,
    defaultOptions = _props$options === void 0 ? [] : _props$options,
    _props$defaultSelcted = props.defaultSelctedId,
    defaultSelctedId = _props$defaultSelcted === void 0 ? '' : _props$defaultSelcted,
    dropdownHeading = props.dropdownHeading,
    searchPlaceholder = props.searchPlaceholder;
  var _useState = useState(''),
    searchString = _useState[0],
    setSearchString = _useState[1];
  var _useState2 = useState([]),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = useState({
      id: '',
      name: ''
    }),
    selectedCity = _useState3[0],
    setSelectedCity = _useState3[1];
  var _useState4 = useState(false),
    showOptions = _useState4[0],
    setShowOptions = _useState4[1];
  var _useState5 = useState(),
    error = _useState5[0],
    setError = _useState5[1];
  useEffect(function () {
    if ((defaultOptions == null ? void 0 : defaultOptions.length) > 0) {
      var _defaultOptions$;
      setOptions(defaultOptions);
      setSelectedCity({
        id: defaultSelctedId,
        name: (_defaultOptions$ = defaultOptions[0]) == null ? void 0 : _defaultOptions$.name
      });
    }
  }, [defaultOptions, defaultSelctedId]);
  var fetchOptionsDebounced = function fetchOptionsDebounced() {
    var _fetchOptions;
    (_fetchOptions = fetchOptions(searchString)) == null || _fetchOptions.then(function (res) {
      var parsedOptions = res.map(function (item) {
        return {
          name: item.displayName,
          id: item.cityCode,
          countryCode: item.countryCode,
          countryName: item.countryName
        };
      });
      setOptions(parsedOptions);
      setError(undefined);
    })["catch"](function (err) {
      setOptions([]);
      setError("Something went wrong, please try again.");
    });
  };
  var citySelectHandler = function citySelectHandler(city) {
    setSelectedCity({
      id: city.id,
      name: city.name
    });
    setShowOptions(false);
    onCitySelect == null || onCitySelect(city);
  };
  useDebounce(fetchOptionsDebounced, searchString, 300);
  return /*#__PURE__*/React.createElement(DropdownContainer, null, /*#__PURE__*/React.createElement(Dropdown, {
    onClick: function onClick() {
      return setShowOptions(!showOptions);
    },
    isActive: showOptions
  }, /*#__PURE__*/React.createElement(SelectLabel, {
    isSelected: !!selectedCity.name
  }, "City"), selectedCity.name && /*#__PURE__*/React.createElement(SelectedOption, null, selectedCity.name)), showOptions && /*#__PURE__*/React.createElement(Dropdown$1, {
    fullView: true,
    listTitle: "",
    heading: dropdownHeading || "Search City",
    handleDropDownClose: function handleDropDownClose() {
      return setShowOptions(false);
    },
    bodyCompoment: /*#__PURE__*/React.createElement(ModalInnerWrapper, null, /*#__PURE__*/React.createElement(SearchResultMenu, {
      selectedID: selectedCity.id,
      options: options,
      handleOptionSelected: citySelectHandler,
      handleSearch: function handleSearch(str) {
        return setSearchString(str);
      },
      selectedValue: selectedCity.name,
      inputPlaceholder: searchPlaceholder || "Enter City name",
      isMWeb: true,
      error: error
    }))
  }));
}
CityDropdown.defaultProps = {
  options: [],
  defaultSelctedId: '',
  dropdownHeading: '',
  searchPlaceholder: ''
};

export { CityDropdown as default };
